import Map, { MAX_ZOOM, MIN_ZOOM } from './Map';

export default Map;
export { default as MapLoading } from './MapLoading';

export { MAX_ZOOM, MIN_ZOOM };
